import React from "react";

export interface AccessTokenContextValue {
  /**
   * A current access token. Call it for every request rather than keeping the
   * result: tokens expire, and this renews them.
   */
  getAccessToken: () => Promise<string>;
}

export const AccessTokenContext = React.createContext<AccessTokenContextValue>({
  getAccessToken: () =>
    Promise.reject(new Error("AccessTokenContext is not provided")),
});
